export default __webpack_public_path__ + "9000c7519bd337ed101e426d2a15e65a.svg";